import React from 'react';
import { Typography } from '@scale/scaleui';
import { ISensorFusionUnifiedProjectLookupDto } from '@scale/sensor-fusion-shared';

import QuickGrab from 'react-scale/corp/components/QM/SharedComponents/QuickGrab';

type SfuTasksOverviewPanelProps = {
  project: ISensorFusionUnifiedProjectLookupDto;
};

// TODO: Short term: links to page with list of relevant tasks IDS
// TODO: Long term: links to task tracker page pre-filtered
// Will need to add Processing, Paused, and Finalizing at a later date.
// TODO: Add: totalTasksCreated, tasksCreatedThisWeek, totalTasksCompleted, tasksCompletedThisWeek
const SfuTasksOverviewPanel = ({ project }: SfuTasksOverviewPanelProps) => {
  const { _id: projectId } = project;

  return (
    <div className="border border-solid border-neutral-200 px-4 py-4 flex flex-col gap-2">
      <Typography.H3>Task Overview</Typography.H3>
      <QuickGrab projectId={projectId} usesPipelineV3 />
    </div>
  );
};

export default SfuTasksOverviewPanel;
